/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Developer_SectionInputs */



/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Profile_Developer_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_developer_section = /** @type {((inputs?: Profile_Developer_SectionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Developer_SectionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Développeur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desarrollador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desenvolvedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sviluppatore")
	return /** @type {LocalizedString} */ ("Developer")
});